import * as tenantGroupSystemNames from '../data/tenantGroupSystemNames.json';
export const TransientReleaseToggles = (env, tenantId) => {
    if (!env) {
        throw new Error('Please provide ENV');
    }
    const activeEnv = (envs) => {
        return Boolean(envs.find((e) => e === '*' || env.startsWith(e)));
    };
    const activeTenants = (tenants) => {
        if (!tenantId) {
            console.log('WARNING! This should never happen. You cannot depend on tenant in a context where tenantId is undefined');
        }
        return Boolean(tenants.find((id) => id === '*' || id === tenantId));
    };
    const sunsetTenantIds = Object.keys(tenantGroupSystemNames.sunsetGroup).map((tenantId) => +tenantId);
    const coopTenantIds = Object.keys(tenantGroupSystemNames.coopGroup).map((tenantId) => +tenantId);
    const sprintingSandboxTenantIds = Object.keys(tenantGroupSystemNames.sprintingSandbox).map((tenantId) => +tenantId);
    return {
        testAllTenantsTransientReleaseToggle() {
            const envs = ['c-env', 'c2-env', 'c3-env'];
            return activeEnv(envs) && activeTenants(['*']);
        },
        testTransientReleaseToggle() {
            const envs = ['c-env', 'c2-env', 'c3-env'];
            return activeEnv(envs) && activeTenants(sunsetTenantIds);
        },
        marketingCardTransientToggle() {
            const envs = ['a-env', 'b-env', 'g-env'];
            return activeEnv(envs) && activeTenants(sunsetTenantIds);
        },
        productCatalogOptimization() {
            const SGConditions = activeEnv(['a-env', 'c-env', 'd-env', 't-env']) && activeTenants([2, 3, 5, 6]);
            const SBConditions = activeEnv(['c-env']) || activeTenants(sunsetTenantIds);
            return SBConditions || SGConditions;
        },
        reducingNumbersOfProductCatalogCalls() {
            const SBConditions = activeTenants(sunsetTenantIds);
            return SBConditions;
        },
        priceRulesJSONDataOptimization() {
            const SBConditions = activeTenants(sunsetTenantIds) && activeEnv(['a-env', 'b-env', 't-env', 'g-env']);
            return SBConditions;
        },
        isTenantVisible() {
            if (tenantId === 103) {
                return activeEnv(['b-env', 'd-spcloud-env', 'e-spcloud-env']);
            }
            return true;
        },
        enableNewProductCatalogPipeline() {
            const envs = ['*'];
            return activeEnv(envs) && (activeTenants(sunsetTenantIds) || activeTenants(sprintingSandboxTenantIds) || activeTenants(coopTenantIds));
        },
        enableProductCatalogObjectInMemoryCaching() {
            if (this.testAllTenantsTransientReleaseToggle()) {
                return false;
            }
            const envs = ['a', 'd', 't', 'e', 'g', 'o', 'q', 'p'];
            return activeEnv(envs);
        },
        enableProductCatalogReleaseOnDemand() {
            if (this.testAllTenantsTransientReleaseToggle()) {
                return false;
            }
            const envs = ['a', 'd', 't', 'e', 'g', 'o', 'q', 'p'];
            return activeTenants(sunsetTenantIds) && activeEnv(envs);
        },
        useInnerCoreGuard() {
            return activeTenants([600, 2]);
        },
    };
};
